module.exports = __webpack_public_path__ + "img/callendar.6fcc5668.svg";